import { useEffect, useState } from 'react';
import { useClient } from 'jsonapi-react';
import { usePlatformAbilities } from '@/hooks/usePlatformAbilities';

// Simulados só aparecem "quando existirem": ability ligada E lista não vazia.
export function useHasSimulados() {
  const client = useClient();
  const { abilities } = usePlatformAbilities();
  const enabled = !!abilities?.['avaliacoes-simulados'];
  const [hasItems, setHasItems] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    client.fetch('question_books?filter[visibility]=open').then(res => {
      if (active) setHasItems(Array.isArray(res?.data) && res.data.length > 0);
    });
    return () => {
      active = false;
    };
  }, [enabled]);

  return enabled && hasItems;
}
